import { Box, CardMedia, Typography } from '@mui/material';

import IdeaCardContent from './IdeaCardContent';
import { Idea } from '../../interfaces/Idea';
import { resolveIdeaImageSrc } from '../../utils/ideaImage';
import { useCachedImage } from '../../hooks/useCachedImage';
import { getPublicAssetUrl } from '../../utils/publicAsset';

export interface ImageIdeaCardProps {
  showBackground: boolean;
  idea: Idea;
}

const ImageIdeaCard = ({ showBackground, idea }: ImageIdeaCardProps) => {
  const imageSrc = resolveIdeaImageSrc(idea);
  const { isLoading: isImageLoading, handleLoad, handleError } = useCachedImage(imageSrc);

  const image = (
    <Box sx={{ position: 'relative' }}>
      {isImageLoading && (
        <Box display="flex" alignItems="center" justifyContent="center" height="100px">
          <CardMedia
            component="img"
            image={getPublicAssetUrl('/img/dotstorming-logo-compact.gif')}
            sx={{ width: 50, height: 50 }}
          />
        </Box>
      )}
      <CardMedia
        component="img"
        image={imageSrc}
        onLoad={handleLoad}
        onError={handleError}
        sx={{ opacity: isImageLoading ? 0 : 1 }}
      />
    </Box>
  );

  if (idea.content) {
    if (idea.title && idea.title.trim().length > 0) {
      return (
        <IdeaCardContent showBackground={showBackground} showPadding={false}>
          {image}
          {idea.title && idea.title.trim().length > 0 && (
            <Typography
              variant="body2"
              sx={{ p: 1.5 }}
              dangerouslySetInnerHTML={{
                __html: idea.title,
              }}
            />
          )}
        </IdeaCardContent>
      );
    } else {
      return image;
    }
  } else if (idea.title && idea.title.trim().length > 0) {
    return (
      <IdeaCardContent showBackground={showBackground} showPadding={false}>
        <Typography
          variant="body2"
          dangerouslySetInnerHTML={{
            __html: idea.title,
          }}
        />
      </IdeaCardContent>
    );
  } else {
    return null;
  }
};

export default ImageIdeaCard;
